import {
    STORE_CHECKOUT_RESET_STEP_INDEX,
    STORE_CHECKOUT_UPDATE_ORDER_ERROR,
    STORE_RESET_CHECKOUT,
} from '@perpay-web/fintech/constants/actionTypes';

export function checkoutResetStepIndex() {
    return {
        type: STORE_CHECKOUT_RESET_STEP_INDEX,
    };
}

export function checkoutUpdateOrderError(error) {
    return {
        type: STORE_CHECKOUT_UPDATE_ORDER_ERROR,
        payload: error,
    };
}

export function resetCheckout() {
    return { type: STORE_RESET_CHECKOUT };
}
